// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX
// MODFIED DATA : 06-12-2025
import { takeLatest, put, all, call } from 'redux-saga/effects';
import staffReportActionTypes from './staff-report.types';
import { staffReportDetailsGet, staffOfficerDetails } from './staff-report.service';
import {
	getStaffDetailsSuccess,
	getStaffDetailsFailure,
	getStaffDetailsResponseChanged,
	getStaffOfficerDetailsSuccess,
	getStaffOfficerDetailsFailure,
	getStaffOfficerDetailsResponseChanged,
} from './staff-report.action';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
/** *********************  START GET MONTHLY PROGRESS DETAILS  ******************** */
export function* getStaffReportList({ payload }: any) {
	try {
		const key = 'StaffDetailsReportKey';
		const { companyID, branchID, officerID, databaseName, fromDate, toDate, limit } = payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			OfficerID: officerID,
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: toDate,
			Limit: limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(staffReportDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getStaffDetailsFailure(responseData.data));
		} else {
			yield put(getStaffDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getStaffDetailsFailure(error));
	}
}

export function* resetGetStaffReportListResponse() {
	yield put(getStaffDetailsResponseChanged());
}

export function* onGetStaffdueReportListDetails() {
	yield takeLatest(staffReportActionTypes.GET_STAFF_DETAILS_START, getStaffReportList);
}

export function* onGetStaffReportListResponseReset() {
	yield takeLatest(
		staffReportActionTypes.GET_STAFF_DETAILS_RESPONSE_RESET,
		resetGetStaffReportListResponse,
	);
}
/** *********************  END GET MONTHLY PROGRESS LIST ******************** */

/** ********************* STAFF OFFICER DETAILS START  ******************** */
export function* GetStaffOfficer({ payload }: any) {
	try {
		const key = 'StaffOfficerKey';
		const jsonData = {
			CompanyID: payload.companyID,
			BranchID: payload.branchID,
			OfficerID: payload.officerID,
			DatabaseName: payload.databaseName,
			FromDate: payload.fromDate,
			ToDate: payload.toDate,
			Limit: payload.limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(staffOfficerDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getStaffOfficerDetailsFailure(responseData.data));
		} else {
			yield put(getStaffOfficerDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getStaffOfficerDetailsFailure(error));
	}
}

export function* resetGetStaffOfficerListResponse() {
	yield put(getStaffOfficerDetailsResponseChanged());
}

export function* onGetStaffOfficerListDetails() {
	yield takeLatest(staffReportActionTypes.GET_STAFF_OFFICER_START, GetStaffOfficer);
}

export function* onGetStaffofficerResponseReset() {
	yield takeLatest(
		staffReportActionTypes.GET_STAFF_OFFICER_RESPONSE_RESET,
		resetGetStaffOfficerListResponse,
	);
}
/** ********************* STAFF OFFICER DETAILS END  ******************** */
export function* StaffReportSaga() {
	yield all([
		call(onGetStaffdueReportListDetails),
		call(onGetStaffReportListResponseReset),
		call(onGetStaffOfficerListDetails),
		call(onGetStaffofficerResponseReset),
	]);
}
